import { inject, Injectable } from '@angular/core';
import { LogicstepCodeParametersApiService } from '@wdx/clmi/clmi-swagger-gen/api-services';
import { LogicStepParameter } from '@wdx/shared/swagger-gen';
import { defer, Observable, shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LogicstepCodeParametersCachedApiService {
    private readonly service = inject(LogicstepCodeParametersApiService);

    private parameterCache = new Map<
        string,
        Observable<LogicStepParameter[]>
    >();

    get(code: string, options = {}): Observable<LogicStepParameter[]> {
        const cached$ = this.parameterCache.get(code);
        if (cached$) {
            return cached$;
        }

        const request$ = defer(() => this.service.get(code, options)).pipe(
            shareReplay(1),
        );

        this.parameterCache.set(code, request$);
        return request$;
    }
}
